<template>
  <div class="ibox">
    <div class="ibox-title">
      Criar Novo Associado
    </div>

    <div class="ibox-content">
      <div class="form-group">
        <label for="associate-name">Nome</label>
        <input v-model="associate.name" id="associate-name" class="form-control">
      </div>

      <div class="form-group">
        <label for="associate-email">E-mail</label>
        <input v-model="associate.email" id="associate-email" class="form-control">
      </div>

      <div class="form-group">
        <label for="associate-token">Token</label>
        <input v-model="associate.token" id="associate-token" class="form-control" placeholder="Se não editar será gerado automaticamente">
      </div>

      <div class="form-group">
        <label for="associate-users">Usuários</label>
        <select2 v-if="optionUsers.length > 0" v-model="associate.userIds"
                 :options="optionUsers" id="associate-users" class="form-control"/>
        <input v-else disabled value="Carregando usuários" class="form-control">
      </div>

      <div class="form-group">
        <label for="associate-accounts">Contas</label>
        <select2 v-if="optionAccounts.length > 0" v-model="associate.accountIds"
                 :options="optionAccounts" id="associate-accounts" class="form-control"/>
        <input v-else disabled value="Carregando contas" class="form-control">
      </div>

      <div class="form-group mt-2">
        <button @click="$router.push('/admin/associates')" class="btn btn-outline btn-lg mr-2">Cancelar</button>
        <button @click="save()" class="btn btn-primary btn-lg">Salvar</button>
      </div>
    </div>

  </div>
</template>

<script>
  import ModelMapper from '@/mixins/ModelMapper'
  import Select2 from '@/components/shares/Select2'

  export default {
    components: { Select2 },
    created() {
      if (this.associate.id) {
        this.buildOptionUsers()
        this.buildOptionAccounts()
      }
    },
    data() {
      return {
        modelPathPrefix: 'admin',
        nameModel: 'Associate',
        optionAccounts: [],
        optionUsers: []
      }
    },
    methods: {
      buildOptionAccounts() {
        const key = 'associateAccounts'
        const options = this.$ls.get(key)
        if (options && options.length > 0) {
          this.optionAccounts = options
          return
        }

        const params = { f: ['id', 'name'] }
        this.axios.get('/admin/accounts', { params })
          .then(response => this.optionAccounts = response.data.map(a => ({ label: `${a.id} - ${a.name}`, value: a.id })))
          .then(() => this.$ls.set(key, this.optionAccounts))
      },
      buildOptionUsers() {
        const key = 'associateUsers'
        const options = this.$ls.get(key)
        if (options && options.length > 0) {
          this.optionUsers = options
          return
        }

        const params = { f: ['id', 'email'] }
        this.axios.get('/admin/users', { params })
          .then(response => this.optionUsers = response.data.map(u => ({label: u.email, value: u.id })))
          .then(() => this.$ls.set(key, this.optionUsers))
      },
      save() {
        this.asyncTemplateSave(this.associate, {
          after: ({model}) => {
            this.$notify.add('Associado Salvo com Sucesso!')
            Object.assign(this.associate, model)
            this.$emit('saveModel')
          }
        })
      }
    },
    mixins: [ModelMapper],
    name: 'Form',
    props: {
      associate: { required: true, type: Object }
    }
  }
</script>

<style scoped>

</style>